import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DialogContent, Typography, CircularProgress, makeStyles } from '@material-ui/core';
import allActions from '../../actions';
import { unoTheme } from '../../assets/styles/unoTheme';
import { useState } from 'react';
import { 
  getFundMovimentoMensalXml, 
  getFundMovimentoTrimestralXml,
  getFundCadastroMensalXml,
  getFundAlteracaoCadastroXml
} from '../../API/fund';
import moment from 'moment';

const modalWidths = {
  big: 'big',
  medium: 'medium',
  sm: 'sm'
};

const DEFAULT_MODAL_WIDTH = modalWidths.medium;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5),
  },
  progressAndMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),

    '& .MuiCircularProgress-root': {
      width: '20px !important',
      height: '20px !important',
      color: unoTheme.mainColor,
      marginRight: theme.spacing(2),
    }
  },
}));

const XmlLoadModal = () => {
  const dispatch = useDispatch();
  const xmlLoad = useSelector(state => state.xmlLoad);
  const { show, message, mainPeriod, xmlType, client, selectedMonth, selectedYear } = xmlLoad;
  const [innerLoadMessage, setInnerLoadMessage] = useState();
  const [modalWidth, setModalWidth] = useState(DEFAULT_MODAL_WIDTH);
  const classes = useStyles();

  const downloadXml = (xmlText, prefix) => {
    const blob = new Blob([xmlText], { type: 'application/xml' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `FUNDO_INVESTIMENTO_${prefix}_${moment().format('YYYYMMDD')}.xml`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const generateAndDownloadXml = async () => {
    setInnerLoadMessage("Gerando XML...");

    const clientId = client.id;
    const month = Number(selectedMonth);
    const year = Number(selectedYear);

    console.log("Gerando XML - Params:", { clientId, month, year, xmlType, mainPeriod });

    if (xmlType == 'transaction' && mainPeriod == 'month') {
      const response = await getFundMovimentoMensalXml(clientId, month, year);
      console.log("Response movimento mensal:", response);
      if (response.success) {
        downloadXml(response.body, 'MOVIMENTO');
      } else {
        const errorMsg = response.body?.message || response.body || 'Erro desconhecido';
        dispatch(allActions.notificationActions.showNotification({
          message: `Erro ao gerar XML de movimento mensal: ${errorMsg}`,
          type: 'error'
        }));
      }
    }

    if (xmlType == 'transaction' && mainPeriod == 'quarter') {
      const response = await getFundMovimentoTrimestralXml(clientId, month, year);
      console.log("Response trimestral:", response);
      if (response.success) {
        downloadXml(response.body, 'TRIMESTRAL');
      } else {
        const errorMsg = response.body?.message || response.body || 'Erro desconhecido';
        dispatch(allActions.notificationActions.showNotification({
          message: `Erro ao gerar XML trimestral: ${errorMsg}`,
          type: 'error'
        }));
      }
    }

    if (xmlType == 'register' && mainPeriod == 'month') {
      const response = await getFundCadastroMensalXml(clientId, month, year);
      console.log("Response cadastro:", response);
      if (response.success) {
        downloadXml(response.body, 'CADASTRO');
      } else {
        const errorMsg = response.body?.message || response.body || 'Erro desconhecido';
        dispatch(allActions.notificationActions.showNotification({
          message: `Erro ao gerar XML de cadastro: ${errorMsg}`,
          type: 'error'
        }));
      }
    }

    if (xmlType == 'alteration') {
      const response = await getFundAlteracaoCadastroXml(clientId, month, year);
      console.log("Response alteração:", response);
      if (response.success) {
        downloadXml(response.body, 'ALTERACAO');
      } else {
        const errorMsg = response.body?.message || response.body || 'Erro desconhecido';
        dispatch(allActions.notificationActions.showNotification({
          message: `Erro ao gerar XML de alteração: ${errorMsg}`,
          type: 'error'
        }));
      }
    }
  };

  useEffect(() => {
    if (show) {
      generateAndDownloadXml({ mainPeriod, xmlType }).finally(() => {
        dispatch(allActions.xmlLoadActions.setXmlLoad({ show: false, message: '' }));
      });
    }
  }, [show, mainPeriod, xmlType, dispatch]);

  return (
    <Dialog
      open={xmlLoad && show}
      fullWidth={true}
      maxWidth={modalWidth == 'big' ? false : 'sm'}
    >
      <DialogContent className={classes.root} style={
        modalWidth == 'big' ? {
          width: '1180px',
          textAlign: 'center',
          margin: '0 auto',
          paddingTop: '40px',
          paddingBottom: '40px',
          pointerEvents: 'none',
        } : {}}>
        <div className={classes.progressAndMessage}>
          <CircularProgress disableShrink />
          <Typography variant={"h6"} align={"center"}>
            {innerLoadMessage ? innerLoadMessage : (message)}
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default XmlLoadModal;